import { message, Switch } from "antd"
import * as ACTIONS from "app/actions/ReportCommunicationProgramAction";




const initialState={
    isLoadingCommunicationProgram: false,
    listCommunicationProgram:[],
    filter:{
        idCommunicationProgram:0
    },

    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },
    isLoadingCoummunicationProgramSelect: false,
    CoummunicationProgramSelect: [],
    isLoadExport: false
}

export const ReportCommunicationProgramAction = (state = initialState, action) =>{
    switch(action.type){
        case ACTIONS.GET_COMMUNICATIONPROGRAM_REQUEST:
            return{
                ...state,
                isLoadingCommunicationProgram: true
            }
        case ACTIONS.GET_COMMUNICATIONPROGRAM_SUCCESS:
            return{
                ...state,
                isLoadingCommunicationProgram: false,
                listCommunicationProgram: action.payload
            }
        case ACTIONS.GET_COMMUNICATIONPROGRAM_FAILURE:
            message.error(action.payload);
            return{
                ...state,
                isLoadingCommunicationProgram: false
            }
        case ACTIONS.GET_REPORTCOMMUNICATIONPROGRAM_REQUEST:
            return{
                ...state,
                isLoadingCoummunicationProgramSelect: true
            }
        case ACTIONS.GET_REPORTCOMMUNICATIONPROGRAM_SUCCESS:
            return{
                ...state,
                isLoadingCoummunicationProgramSelect: false,
                CoummunicationProgramSelect: action.payload,
                pagination: {
                    ...state.pagination,
                    total: action.payload.length > 0 ? action.payload[0].totalCount : 0,
                }
            }
        case ACTIONS.GET_REPORTCOMMUNICATIONPROGRAM_FAILURE:
            message.error(action.payload);
            return{
                ...state,
                isLoadingCoummunicationProgramSelect: false
            }
        case ACTIONS.SAVE_FILTER_REPORTCOMMUNICATIONPROGRAM:
            return{
                ...state,
                filter: action.payload
            }
        case ACTIONS.CLEAR_GRID_REPORTCOMMUNICATIONPROGRAM:
            return{
                ...state,
                isLoadingCoummunicationProgramSelect: false,
                CoummunicationProgramSelect: action.payload
            }



        //Exporta los datos
        case ACTIONS.EXPORT_COMMUNICATIONPROGRAM_REQUEST:
            return {
                ...state,
                isLoadExport: true
            }
        case ACTIONS.EXPORT_COMMUNICATIONPROGRAM_SUCCESS:
            return {
                ...state,
                isLoadExport: false
            }
        case ACTIONS.EXPORT_COMMUNICATIONPROGRAM_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadExport: false
            }

        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }

            
        default:
            return state;
    }
}